const { forceBaseUrl, beforeQuery, afterQuery, query, getApiUrl, getSwagger } = require("./services/cloudaccounting");

const { getToken, setToken } = require("./services/token");

const methods = require("./helpers/methods");

const { getBranding } = require("./services/branding");
const login = require("./services/authentication/login");
const logout = require("./services/authentication/logout");

const { init: initFrameManager, onMessage, sendMessage } = require(`./services/frame-manager`);

const storage = require(`./services/storage`);

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get("token")) {
	const urlToken = urlParams.get("token");
	const lsToken = getToken();

	if (methods.getDebugMode()) {
		console.log("urlToken", urlToken);
		console.log("lsToken", lsToken);
	}

	(async () => {
		if (!lsToken || (lsToken && urlToken !== lsToken)) {
			if (methods.getDebugMode()) {
				console.log("Force login using the urlToken");
			}

			await login({
				token: urlToken
			});
		}
	})();
} else {
	(async () => {
		await login({
			token: getToken()
		});
	})();
}

initFrameManager();

const sinao = {
	getBranding,
	forceBaseUrl,
	getApiUrl,
	query,
	login,
	logout,
	getToken,
	setToken,
	getApiUrl,
	beforeQuery,
	afterQuery,
	onMessage,
	sendMessage,
	getSwagger,
	storage,
	...methods
};

if (typeof window !== "undefined") {
	Object.assign(window, sinao);

	// window["sinao-corejs"] = sinao;
}

module.exports = { ...sinao };
